
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotels/toplists/[id]",
      function () {
        return require("private-next-pages/hotels/toplists/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotels/toplists/[id]"])
      });
    }
  